import { ButtonGroup, styled } from '@mui/material';

const StyledAvailabilityContainer = styled(ButtonGroup)(() => ({
  alignItems: 'center',
  height: '100%'
}));

export default StyledAvailabilityContainer;
